'use strict';

var _    = require('underscore');
var $    = require('jquery');
var TabSubNavButton = require('./tab__subnav__group__button.js');

/**
 * Creates a submenu toggle button
 *
 * @class
 */

class TabSubNavToggleButton extends TabSubNavButton {
    /**
     * @event SubNavToggleButton#Cioui:SubNavToggleButton:clicked
     * @property {String}Cioui:SubNavToggleButton:clicked
     * @returns {Object} event - native click Event
     */

    _clicked(e){
        e.preventDefault();
        $(e.currentTarget).trigger('Cioui:SubNavToggleButton:clicked', e);
    }

    /*
     * Make a tool disabled
     */
    setActive(){
        $('.js-editor__tab__subnav__button__btn', this.$el).removeClass('editor__tab__subnav__button__btn').addClass('editor__tab__subnav__button__btn--active');
    }

    /*
     * Enable a tool after it has been disabled
     */
    setInActive(){
        $('.js-editor__tab__subnav__button__btn', this.$el).removeClass('editor__tab__subnav__button__btn--active').addClass('editor__tab__subnav__button__btn');
    }
}

module.exports = TabSubNavToggleButton;